import Raven from 'raven-js';
import { registerQuery, useQuery } from 'data-fetching-client';
import { fetchNativeIntegrationAppStatus } from '../api/marketplace';
import { getLinkedInSalesNavigatorId, INTEGRATION_STATUS_CONNECTED } from '../constants/marketplaceConstants';
const linkedInIntegrationStatus = registerQuery({
  fieldName: 'hasLinkedInIntegration',
  args: [],
  fetcher: () => {
    return fetchNativeIntegrationAppStatus(getLinkedInSalesNavigatorId()).then(integrationStatus => integrationStatus === INTEGRATION_STATUS_CONNECTED);
  }
});
export function useLinkedInStatus() {
  const {
    data,
    loading
  } = useQuery(linkedInIntegrationStatus, {
    onError: error => {
      Raven.captureException(error, {
        fingerprint: ['ERROR_API_LINKEDIN_STATUS_FAILED'],
        extra: {
          message: 'Failed to fetch LinkedIn connection status'
        }
      });
    }
  });
  return {
    hasLinkedInIntegration: Boolean(data && data.hasLinkedInIntegration),
    loading
  };
}